<mat-toolbar class="w-full">
  <div class="header-content flex items-center w-full">
    @if (showLogoButton) {
      <button (click)="routeToLandingPage()">
        <img
          title="Captire Logo"
          src="../../../assets/icons/logo.svg"
          class="cursor-pointer"
          />
        </button>
      }
      <span class="menu-spacer"></span>
      <div>
        @if (!isMobile) {
          @for (link of links; track link) {
            <button
              mat-button
              [routerLink]="link.routerLink"
              (click)="link.action()"
              routerLinkActive="active"
              >
              {{ link.label | translate }}
            </button>
          }
        }

        @if (isMobile) {
          <mat-menu #menu="matMenu">
            @for (link of links; track link) {
              <button
                mat-menu-item
                [routerLink]="link.routerLink"
                (click)="link.action()"
                routerLinkActive="active"
                >
                {{ link.label | translate }}
              </button>
            }
          </mat-menu>
          <button mat-button [matMenuTriggerFor]="menu">
            <mat-icon>menu</mat-icon>
          </button>
        }
      </div>
      <button
        mat-button
        [matMenuTriggerFor]="languageMenu"
        class="flex items-center"
        >
        <img
          [src]="LANGUAGE_FLAGS[selectedLanguage() || 'en']"
          alt="Current Language"
          width="25px"
          height="auto"
          />
        </button>
        <mat-menu #languageMenu="matMenu" yPosition="below" xPosition="before">
          @for (lang of LANGUAGES; track lang) {
            <button
              mat-menu-item
              (click)="changeLanguage(lang.code)"
              >
              <div class="flex flex-1">
                <img
                  [src]="LANGUAGE_FLAGS[lang.code]"
                  [alt]="lang.name"
                  class="flag-icon"
                  />
                  <span class="ml-2">{{ lang.name }}</span>
                </div>
              </button>
            }
          </mat-menu>
        </div>
      </mat-toolbar>
